import { isDefaultTenantPortal } from '@/config/tenant-site'
import { useTenantFeatures } from '@/shared/hooks/useTenantFeatures'

/** 是否展示全平台赛事列表(default 门户 / 超管授权 contests_global_catalog) */
export function useGlobalContestsCatalog() {
  const { isEnabled } = useTenantFeatures()
  return isDefaultTenantPortal() || isEnabled('contests_global_catalog')
}

/** 是否展示全平台任务列表(default 门户 / 超管授权 tasks_global_catalog) */
export function useGlobalTasksCatalog() {
  const { isEnabled } = useTenantFeatures()
  return isDefaultTenantPortal() || isEnabled('tasks_global_catalog')
}

/** default 租户门户展示全平台作品广场 */
export function useGlobalWorksCatalog() {
  return isDefaultTenantPortal()
}
